import { LocalStorageUtil as LocalStorageUtil$1, TimeUtil as TimeUtil$1, IanaTimezones as IanaTimezones$1 } from '@cue/utility';
import React, { useEffect, useState } from 'react';
import { jsx, useTheme } from '@emotion/react';
import _styled from '@emotion/styled/base';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import durationPlugin from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
export { default as isBetween } from 'dayjs/plugin/isBetween';
import isSameOrafter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import timezonePlugin from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { Heading, Text, Input, Checkbox, Button, Link, ThemedIcon } from '@cue/atoms';
import { useModal, Modal } from '@cue/organisms';
import { useForm } from 'react-hook-form';
import { createPortal } from 'react-dom';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

var AnalyticsTransformer = /*#__PURE__*/function () {
  function AnalyticsTransformer() {
    var _this = this;
    _classCallCheck(this, AnalyticsTransformer);
    _defineProperty(this, "MA", void 0);
    _defineProperty(this, "tracker", void 0);
    _defineProperty(this, "playerName", 'Default Player');
    _defineProperty(this, "currentData", null);
    _defineProperty(this, "transformTrackingEvent", function (data) {
      var type = data.type;
      if (type === 'event') {
        _this.transformEvent(data);
      }
      if (type === 'media') {
        _this.transformMediaEvent(data);
      }
    });
    _defineProperty(this, "setPlayername", function (playerName) {
      if (playerName) _this.playerName = playerName;
    });
    _defineProperty(this, "mediaTrackLoadedmetadata", function (_ref) {
      var _this$currentData, _this$currentData2;
      var target = _ref.target;
      _this.transformMediaEvent({
        name: 'start',
        type: 'media',
        src: (_this$currentData = _this.currentData) === null || _this$currentData === void 0 ? void 0 : _this$currentData.src,
        data: {
          title: _this === null || _this === void 0 || (_this$currentData2 = _this.currentData) === null || _this$currentData2 === void 0 ? void 0 : _this$currentData2.title,
          totalLengthInSeconds: target.duration
        }
      });
    });
    _defineProperty(this, "mediaTrackPlay", function () {
      _this.transformMediaEvent({
        type: 'media',
        name: 'play'
      });
    });
    _defineProperty(this, "mediaTrackPause", function () {
      _this.transformMediaEvent({
        type: 'media',
        name: 'pause'
      });
    });
    _defineProperty(this, "mediaTrackSeeked", function (_ref2) {
      var target = _ref2.target;
      _this.transformMediaEvent({
        type: 'media',
        name: 'seeked',
        data: {
          progressInSeconds: target.currentTime,
          totalLengthInSeconds: target.duration
        }
      });
    });
    _defineProperty(this, "mediaTrackTimeupdate", function (_ref3) {
      var target = _ref3.target;
      _this.transformMediaEvent({
        type: 'media',
        name: 'timeupdate',
        data: {
          progressInSeconds: target.currentTime,
          totalLengthInSeconds: target.duration
        }
      });
    });
    _defineProperty(this, "mediaTrackEnded", function () {
      _this.transformMediaEvent({
        type: 'media',
        name: 'ended'
      });
    });
    _defineProperty(this, "bindMediaTracking", function (ref, args) {
      console.debug('Matomo Bind Media Analytics', args);
      _this.currentData = args;
      ref.addEventListener('loadedmetadata', _this.mediaTrackLoadedmetadata);
      ref.addEventListener('play', _this.mediaTrackPlay);
      ref.addEventListener('pause', _this.mediaTrackPause);
      ref.addEventListener('ended', _this.mediaTrackEnded);
      ref.addEventListener('seeked', _this.mediaTrackSeeked);
      ref.addEventListener('timeupdate', _this.mediaTrackTimeupdate);
    });
    _defineProperty(this, "unbindMediaTracking", function (ref) {
      if (!ref) {
        return;
      }
      console.debug('Unbind Media Analytics');
      _this.currentData = null;
      ref.removeEventListener('loadedmetadata', _this.mediaTrackLoadedmetadata);
      ref.removeEventListener('play', _this.mediaTrackPlay);
      ref.removeEventListener('pause', _this.mediaTrackPause);
      ref.removeEventListener('ended', _this.mediaTrackEnded);
      ref.removeEventListener('seeked', _this.mediaTrackSeeked);
      ref.removeEventListener('timeupdate', _this.mediaTrackTimeupdate);
    });
    _defineProperty(this, "transformEvent", function (_ref4) {
      var category = _ref4.category,
        action = _ref4.action,
        data = _ref4.data;
      var trackData = ["".concat(category), "".concat(action), "".concat(JSON.stringify(data))];
      console.debug('Event', ['trackEvent'].concat(trackData));
      window._paq.push(['trackEvent'].concat(trackData));
    });
    _defineProperty(this, "transformMediaEvent", function (input) {
      var name = input.name,
        src = input.src,
        data = input.data,
        context = input.context,
        _input$source = input.source,
        source = _input$source === void 0 ? null : _input$source;
      console.debug('MATOMO MEDIA', input);
      var _ref5 = context || {},
        _ref5$topics = _ref5.topics,
        _ref5$topics2 = _ref5$topics === void 0 ? [] : _ref5$topics,
        _ref5$topics3 = _slicedToArray(_ref5$topics2, 1),
        altTitle = _ref5$topics3[0];
      var _ref6 = data || {
          title: '',
          totalLengthInSeconds: 0,
          progressInSeconds: 0
        },
        _ref6$title = _ref6.title,
        title = _ref6$title === void 0 ? '' : _ref6$title,
        _ref6$totalLengthInSe = _ref6.totalLengthInSeconds,
        totalLengthInSeconds = _ref6$totalLengthInSe === void 0 ? 0 : _ref6$totalLengthInSe,
        _ref6$progressInSecon = _ref6.progressInSeconds,
        progressInSeconds = _ref6$progressInSecon === void 0 ? 0 : _ref6$progressInSecon;
      if (!_this.MA) {
        var _window;
        _this.MA = (_window = window) === null || _window === void 0 || (_window = _window.Matomo) === null || _window === void 0 ? void 0 : _window.MediaAnalytics;
      }
      if (!_this.MA) {
        return false;
      }
      switch (name) {
        case 'start':
        case 'load':
          if (source) {
            _this.playerName = source;
          }
          _this.tracker = new _this.MA.MediaTracker(_this.playerName, _this.MA.mediaType.VIDEO, src);
          _this.tracker.setMediaTitle("".concat(title || altTitle || src).concat(context ? "||".concat(JSON.stringify(_objectSpread2({}, context))) : ''));
          _this.tracker.setMediaTotalLengthInSeconds(totalLengthInSeconds);
          _this.tracker.play(); // need to come from showroom

          break;
        default:
          if (!_this.tracker) {
            console.warn('Matomo Media was not initialized');
            return false;
          }
          switch (name) {
            case 'play':
              _this.tracker.play();
              break;
            case 'pause':
              _this.tracker.pause();
              break;
            case 'ended':
              _this.tracker.finish();
              break;
            case 'timeupdate':
              _this.tracker.setMediaProgressInSeconds(progressInSeconds);
              _this.tracker.setMediaTotalLengthInSeconds(totalLengthInSeconds);
              _this.tracker.update();
              break;
            case 'seeked':
              _this.tracker.seekStart();
              _this.tracker.setMediaProgressInSeconds(progressInSeconds);
              _this.tracker.setMediaTotalLengthInSeconds(totalLengthInSeconds);
              _this.tracker.seekFinish();
              break;
            default:
              return;
          }
      }
    });
    if (typeof window !== 'undefined' && window.Matomo) {
      this.MA = window.Matomo.MediaAnalytics;
    }
  }
  _createClass(AnalyticsTransformer, null, [{
    key: "setUserData",
    value: function setUserData() {
      var _ref7 = LocalStorageUtil$1.get('user') || {},
        userId = _ref7.userId,
        customDimensions = _ref7.customDimensions;
      console.info('MATOMO USER: ', userId, customDimensions);
      try {
        if (!window._paq) {
          window._paq = [];
        }
        if (userId) {
          window._paq.push(['setUserId', userId]);
        }
        if (customDimensions) {
          window._paq.push(['setCustomDimension', 1, customDimensions]);
        }
        window._paq.push(['trackPageView']);
      } catch (error) {
        console.warn(error);
      }
    }
  }, {
    key: "scanForMedia",
    value: function scanForMedia() {
      try {
        if (!window._paq) {
          window._paq.push(['MediaAnalytics::enableMediaAnalytics']);
          window._paq.push(['MediaAnalytics::scanForMedia']);
          console.info('MATOMO SCAN FOR MEDIA');
        }
      } catch (error) {
        console.warn(error);
      }
    }
  }, {
    key: "getMediaTracker",
    value: function getMediaTracker() {
      return typeof window !== 'undefined' && window.Matomo ? window.Matomo.MediaAnalytics : null;
    }

    // tslint:disable-next-line: no-any
  }, {
    key: "customEvent",
    value: function customEvent() {
      var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      try {
        // if tracking comes from within an iframe, use window.top instead of window
        if (window.top) {
          window.top._paq.push(['trackEvent'].concat(_toConsumableArray(params)));
          console.debug('Event', ['trackEvent'].concat(_toConsumableArray(params)), '(using window.top)');
          return;
        }
        console.debug('Event', ['trackEvent'].concat(_toConsumableArray(params)));
        window._paq.push(['trackEvent'].concat(_toConsumableArray(params)));
      } catch (error) {
        console.debug(error);
      }
    }

    // tslint:disable-next-line: no-any
  }, {
    key: "customKeyEvent",
    value: function customKeyEvent(key) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      try {
        // if tracking comes from within an iframe, use window.top instead of window
        if (window.top) {
          window.top._paq.push([key].concat(_toConsumableArray(params)));
          console.debug('Event', [key].concat(_toConsumableArray(params)), '(using window.top)');
          return;
        }
        console.debug('Event', [key].concat(_toConsumableArray(params)));
        window._paq.push([key].concat(_toConsumableArray(params)));
      } catch (error) {
        console.debug(error);
      }
    }
  }]);
  return AnalyticsTransformer;
}();
var LoadAnalytics = function LoadAnalytics() {
  var tracking;
  useEffect(function () {
    tracking = new AnalyticsTransformer();
    window.removeEventListener('message', listenFrameEvent);
    window.addEventListener('message', listenFrameEvent);
    return function () {
      window.removeEventListener('message', listenFrameEvent);
    };
  }, []);
  var listenFrameEvent = function listenFrameEvent(frameEvent) {
    var data = frameEvent.data;
    // Wrap rootless object into analytics:{}
    var _ref8 = data.type === 'event' ? {
        analytics: data
      } : data,
      analytics = _ref8.analytics;
    var source = 'Fairtouch'; // TODO origin === fairtouchConfig.uri ? 'Fairtouch' : 'Showroom';

    if (analytics) {
      if (tracking) {
        tracking.transformTrackingEvent(_objectSpread2(_objectSpread2({}, analytics), {}, {
          source: source
        }));
      }
    }
  };
  return jsx("span", {
    style: {
      display: 'none'
    }
  });
};

// https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
var BrowserUtil = /*#__PURE__*/function () {
  function BrowserUtil() {
    _classCallCheck(this, BrowserUtil);
  }
  _createClass(BrowserUtil, null, [{
    key: "isAndroid",
    value: function isAndroid() {
      return /Mobi|Android/i.test(navigator.userAgent);
    }
  }, {
    key: "isSafari",
    value: function isSafari() {
      var userAgent = navigator.userAgent.toLowerCase();
      return userAgent.includes('safari') && !userAgent.includes('chrome');
    }
  }, {
    key: "isFirefox",
    value: function isFirefox() {
      var userAgent = navigator.userAgent.toLocaleLowerCase();
      return userAgent.includes('firefox') && !userAgent.includes('seamonkey');
    }

    /**
     * Returns true if the calling browser is Microsoft Edge but before Microsoft used
     * the Chromium engine for it (so Version 18 and lower)
     */
  }, {
    key: "isLegacyEdge",
    value: function isLegacyEdge() {
      var userAgent = navigator.userAgent.toLocaleLowerCase();

      // the Chromium Edge uses "edg" instead of "edge" as userAgent
      return userAgent.includes('edge');
    }

    // https://stackoverflow.com/a/9039885
  }, {
    key: "isIOs",
    value: function isIOs() {
      return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      navigator.userAgent.includes('Mac') && 'ontouchend' in document;
    }
  }, {
    key: "isMobile",
    value: function isMobile() {
      return BrowserUtil.isIOs() || BrowserUtil.isAndroid();
    }
  }]);
  return BrowserUtil;
}();

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var DATA_PRE_KEY = 'cue-ls-data';
var LocalStorageUtil = /*#__PURE__*/function () {
  function LocalStorageUtil() {
    _classCallCheck(this, LocalStorageUtil);
  }
  _createClass(LocalStorageUtil, null, [{
    key: "get",
    value:
    /**
     * get a single string from the localstorage
     *
     * @param key
     */
    function get(key) {
      if (typeof localStorage === 'undefined') {
        return null;
      }
      var data = localStorage.getItem(key);
      if (!data) return null;
      try {
        var dataFromLocalStorage = JSON.parse(data);
        return dataFromLocalStorage[DATA_PRE_KEY];
      } catch (e) {
        console.error("Cant get localstorage ".concat(e));
        return null;
      }
    }

    /**
     * set any primitive or serializable data to localStorage
     *
     * @param key
     * @param data
     */
  }, {
    key: "set",
    value: function set(key, data) {
      if (typeof localStorage === 'undefined') {
        return null;
      }
      try {
        localStorage.setItem(key, JSON.stringify(_defineProperty({}, DATA_PRE_KEY, data)));
        return true;
      } catch (e) {
        return false;
      }
    }

    /**
     * Removes an element from local storage
     * @param key
     */
  }, {
    key: "remove",
    value: function remove(key) {
      if (typeof localStorage === 'undefined') {
        return;
      }
      localStorage.removeItem(key);
      if (this.get(key) === undefined) {
        return true;
      }
      return false;
    }
  }]);
  return LocalStorageUtil;
}();

var _class;
dayjs.extend(utc);
dayjs.extend(advancedFormat);
dayjs.extend(timezonePlugin);
dayjs.extend(durationPlugin);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrafter);
dayjs.extend(LocalizedFormat);
dayjs.extend(isBetween);
dayjs.extend(customParseFormat);
var MOCK_TIME = 'mockTime';
var MOCK_TIME_ZONE = 'mockTimezone';
var userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
var TimeUtil = /*#__PURE__*/function () {
  function TimeUtil() {
    _classCallCheck(this, TimeUtil);
  }
  _createClass(TimeUtil, null, [{
    key: "getTimezoneString",
    value:
    /**
     * Returns a string like "UTC+01:00", "UTC-05:00", ...
     * By passing in an optional config, the function may return an arbitrary string, if the
     * string matches the timezone and the config
     *
     * @param offset
     */
    function getTimezoneString(date, tz, config) {
      var timezoneData = {
        a: {
          b: {
            dst: '',
            nonDst: ''
          }
        }
      };
      var isDst = TimeUtil.getIsDst(date, tz);

      // if a custom config is given, use it
      if (config) {
        var mappings = config.mappings;
        var match = mappings.find(function (_ref) {
          var dst = _ref.dst,
            timezone = _ref.timezone;
          return dst === isDst && timezone === tz;
        });
        if (match) {
          return match.string;
        }
      }

      // this turns something like 'Europe/Berlin' into ['Europe', 'Berlin']
      var splittedTimezone = tz.split('/');
      if (
      // this checks for the continent, for example 'Europe'
      timezoneData[splittedTimezone[0]] &&
      // this checks for the city within the continent, for example 'Berlin'
      timezoneData[splittedTimezone[0]][splittedTimezone[1]]) {
        // this gets the dst time and non dst time from the data entry
        var _timezoneData$splitte = timezoneData[splittedTimezone[0]][splittedTimezone[1]],
          dst = _timezoneData$splitte.dst,
          nonDst = _timezoneData$splitte.nonDst;

        // return either the dst or nonDst time
        return isDst ? dst : nonDst;
      }
      return dayjs().tz(tz).format('UTCZ');
    }

    /**
     * Returns the current user's time zone as detected by the browser
     */
  }, {
    key: "getUsersTimezone",
    value: function getUsersTimezone() {
      var mockTimezone = LocalStorageUtil.get(MOCK_TIME_ZONE);
      if (mockTimezone) {
        return mockTimezone;
      }

      // this gets the time zone from the browser
      return userTimezone; // Intl.DateTimeFormat().resolvedOptions().timeZone;
    }

    /**
     * Returns a duration object based on a given time in ms
     *
     * @param ms
     */
  }]);
  return TimeUtil;
}();
_class = TimeUtil;
/**
 * Returns an instance in local time for a given string representation of a date
 */
_defineProperty(TimeUtil, "get", function (s) {
  var tz = _class.getUsersTimezone();
  return dayjs.tz(s, tz);
});
/**
 * Returns an instance in UTC time zone for a given string
 */
_defineProperty(TimeUtil, "getUtc", function (s, format) {
  return dayjs.utc(s, format);
});
/**
 * Returns an instance with the current time based on your local time
 */
_defineProperty(TimeUtil, "getNow", function () {
  var mockTime = LocalStorageUtil.get(MOCK_TIME);
  var timezone = _class.getUsersTimezone();
  if (mockTime && mockTime.freezedMockDate) {
    return dayjs.tz(dayjs.utc(mockTime.freezedMockDate), timezone);
  }
  if (mockTime && mockTime.mockDiffMs) {
    return dayjs().tz(timezone).subtract(mockTime.mockDiffMs);
  }
  return dayjs().tz(timezone);
});
/**
 * Returns true, if there is a mock time set
 */
_defineProperty(TimeUtil, "getIsMockTime", function () {
  var mockTime = LocalStorageUtil.get(MOCK_TIME);
  return !!mockTime;
});
/**
 * Returns an instance with the current utc time
 * @param s
 */
_defineProperty(TimeUtil, "getNowUtc", function () {
  var mockTime = LocalStorageUtil.get(MOCK_TIME);
  if (mockTime && mockTime.freezedMockDate) {
    return dayjs.utc(mockTime.freezedMockDate);
  }
  if (mockTime && mockTime.mockDiffMs) {
    return dayjs.utc().subtract(mockTime.mockDiffMs);
  }
  return dayjs.utc();
});
/**
 * Converts a given instance into an instance in utc time
 *
 * @param d
 */
_defineProperty(TimeUtil, "convertToUtc", function (d) {
  return d.utc();
});
/**
 * Converts a given instance into a given timezone
 */
_defineProperty(TimeUtil, "convertToTimeZone", function (d, timezone) {
  return d.tz(timezone);
});
/**
 * Returns the UTC offset for a given timezone
 */
_defineProperty(TimeUtil, "getUtcOffsetForTz", function (tz) {
  return dayjs.utc().tz(tz).utcOffset();
});
/**
 * Returns true if a given time zone is in DST right now
 * @param tz
 */
_defineProperty(TimeUtil, "getIsDst", function (date, tz) {
  // https://stackoverflow.com/a/11888430
  var jan = dayjs.tz('2020-01-01', tz);
  var jun = dayjs.tz('2020-06-01', tz);

  // if there is no difference, there is no DST for the given time zone
  if (jan.utcOffset() === jun.utcOffset()) {
    return false;
  }
  return dayjs.tz(date.format('YYYY-MM-DDD'), tz).utcOffset() === jun.utcOffset();
});
_defineProperty(TimeUtil, "getDuration", function (ms) {
  return dayjs.duration(ms, 'ms');
});
/**
 * Setting i18n
 *
 * Example:
 * import locale_de from 'dayjs/locale/de'
 * TimeUtil.setLocale(locale_de)
 */
_defineProperty(TimeUtil, "setLocale", function (locale) {
  return dayjs.locale(locale);
});
_defineProperty(TimeUtil, "getDayjs", function () {
  return dayjs;
});
_defineProperty(TimeUtil, "getAbbrName", function () {
  return dayjs().format('z');
});
_defineProperty(TimeUtil, "isToday", function (date) {
  if (!date) return false;
  var comparisonTemplate = 'YYYY-MM-DD';
  return dayjs.utc(date).format(comparisonTemplate) === _class.getNow().format(comparisonTemplate);
});
/**
 * Extend dayjs with given Plugin
 */
_defineProperty(TimeUtil, "extend", function (plugin) {
  return dayjs.extend(plugin);
});
/**
 * returns the localized date range string
 *
 */
_defineProperty(TimeUtil, "getRangeString", function (start, end) {
  var hideTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var localeFormat = dayjs.Ls[dayjs.locale()].formats.LL || 'MMMM D, YYYY'; // fallback EN locale
  var LLWithoutYear = localeFormat.replace(', YYYY', '').replace('YYYY', '') || 'LL';
  var dayFormat = localeFormat.includes('D.') ? 'D.' : 'D';
  var yearFormat = localeFormat.includes(', YYYY') ? ', YYYY' : 'YYYY';

  // Same Date
  if (start.format('HHmmDMYYYY') === end.format('HHmmDMYYYY')) {
    return start.format("LL".concat(!hideTime ? 'L' : ''));
  }

  // Same Day
  if (start.format('DMYYYY') === end.format('DMYYYY')) {
    if (hideTime) {
      return start.format('LL');
    }
    return "".concat(start.format('LLL'), " - ").concat(end.format('LT'));
  }

  // Same Month
  if (start.format('MMYYYY') === end.format('MMYYYY')) {
    var localLL = localeFormat === null || localeFormat === void 0 ? void 0 : localeFormat.replace(dayFormat, "".concat(start.format(dayFormat)).concat(!hideTime ? ' LT ' : '', " - ").concat(end.format(dayFormat)).concat(!hideTime ? ' LT ' : ''));
    return end.format(localLL);
  }

  // Same Year
  if (start.format('YYYY') === end.format('YYYY')) {
    return "".concat(start.format("".concat(LLWithoutYear, " ").concat(!hideTime ? ' LT ' : '')), " - ").concat(end.format("".concat(LLWithoutYear).concat(!hideTime ? ' LT' : '').concat(yearFormat))).trim();
  }
  return "".concat(start.format("".concat(LLWithoutYear).concat(yearFormat).concat(!hideTime ? ' LT ' : '')), " - ").concat(end.format("".concat(LLWithoutYear).concat(yearFormat).concat(!hideTime ? ' LT ' : ''))).trim();
});

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var DebugState = function DebugState() {
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    mockTime = _useState2[0],
    setMocktime = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    mockTimezone = _useState4[0],
    setMocktimezone = _useState4[1];
  var _useState5 = useState(TimeUtil$1.getNow()),
    _useState6 = _slicedToArray(_useState5, 2),
    mockCurrentTime = _useState6[0],
    setMockCurrentTime = _useState6[1];
  useEffect(function () {
    var interval = setInterval(function () {
      setMockCurrentTime(TimeUtil$1.getNow());
    }, 1000);
    return function () {
      return clearInterval(interval);
    };
  }, [mockTime]);
  useEffect(function () {
    setMocktime(LocalStorageUtil$1.get('mockTime') || '');
    setMocktimezone(LocalStorageUtil$1.get('mockTimezone') || '');
  }, [LocalStorageUtil$1]);
  return mockTime || mockTimezone ? jsx(DebugStateContainer, null, jsx(React.Fragment, null, mockTime && jsx("span", null, jsx("strong", null, "Custom mock time:"), " ", mockCurrentTime.format('DD.MM.YY HH:mm:ss'))), jsx(React.Fragment, null, mockTimezone && jsx("span", null, jsx("strong", null, "Custom mock timezone:"), " ", mockTimezone)), jsx(React.Fragment, null, mockTime && jsx("span", null, jsx("strong", null, " Custom mock UTC:"), ' ', TimeUtil$1.convertToUtc(mockCurrentTime).format('DD.MM.YY HH:mm:ss')))) : jsx(React.Fragment, null);
};
var DebugStateContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "evolukc0"
} : {
  target: "evolukc0",
  label: "DebugStateContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "16ratfw",
  styles: "padding:5px;color:black;width:100vw;background:red;position:fixed;top:0;left:0;right:0;background:#ffb900;z-index:99999;span{margin-right:20px;}"
} : {
  name: "16ratfw",
  styles: "padding:5px;color:black;width:100vw;background:red;position:fixed;top:0;left:0;right:0;background:#ffb900;z-index:99999;span{margin-right:20px;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var DebugMenu = function DebugMenu() {
  return withDebugMenuControls(DebugMenuContent);
};
var DebugMenuContent = function DebugMenuContent(_ref) {
  var onMockDateSave = _ref.onMockDateSave,
    defaultValueMockDateFreeze = _ref.defaultValueMockDateFreeze,
    onMockDateReset = _ref.onMockDateReset,
    onMockTimezoneSave = _ref.onMockTimezoneSave,
    defaultValueMockTimezone = _ref.defaultValueMockTimezone,
    onMockTimezoneReset = _ref.onMockTimezoneReset;
  var _useForm = useForm(),
    registerMockDate = _useForm.register,
    handleSubmitMockDate = _useForm.handleSubmit;
  var _useForm2 = useForm(),
    registerMockTimezone = _useForm2.register,
    handleSubmitMockTimezone = _useForm2.handleSubmit;
  var timezone = TimeUtil.getUsersTimezone();
  var now = TimeUtil.getNowUtc();
  var nowInTimezone = TimeUtil.convertToTimeZone(now, timezone);
  var _ref2 = [nowInTimezone.format('YYYY-MM-DD'), nowInTimezone.format('HH:mm:ss')],
    defaultMockDate = _ref2[0],
    defaultMockTime = _ref2[1];
  return jsx(Container, null, jsx(Heading, null, "Debug Menu"), jsx(Heading, {
    type: "h2"
  }, "Mock time"), jsx(Text, null, "If you freeze the mock time, \"now\" will ALWAYS be that time. For example if you set it to 2020-01-01 at 09:00 now, it will be 09:00 in an hour as well. If you don't freeze it, it will be 10:00 in an hour. Note that components that repeatedly update the current time, like a countdown, won't change with freezed mock time"), jsx("form", {
    onSubmit: handleSubmitMockDate(function (data) {
      if (!onMockDateSave) {
        return;
      }

      // converting the date and time data into a YYYY-MM-DDTHH:mm:ss format
      var dateString = "".concat(data.mockDate, "T").concat(data.mockTime);
      var freezedTime = TimeUtil.get("".concat(data.mockDate, "T").concat(data.mockTime)).utc().format();
      if (data.freezeMockTime) {
        onMockDateSave({
          freezedMockDate: "".concat(freezedTime)
        });
        return;
      } else {
        var _mockDate = TimeUtil.get(dateString).utc();
        // can't use TimeUtil.getNowUtc() here, because we want the real utc time, no matter if a
        // mock time has been set before or not
        var diff = dayjs.utc().diff(_mockDate, 'ms');
        onMockDateSave({
          mockDiffMs: diff
        });
      }
    })
  }, jsx(Row, null, jsx(Col, null, "Mock Date:"), jsx(Col, null, jsx(Input, _extends({}, registerMockDate('mockDate', {
    required: true
  }), {
    type: "date",
    defaultValue: defaultMockDate,
    key: defaultMockDate
  }))), jsx(Col, null, jsx(Input, _extends({}, registerMockDate('mockTime', {
    required: true
  }), {
    type: "time",
    defaultValue: defaultMockTime,
    key: defaultMockTime,
    step: "1"
  }))), jsx(Col, null, jsx(Checkbox, _extends({
    id: "freezeMockTime",
    label: "Freeze mock time",
    defaultChecked: defaultValueMockDateFreeze
  }, registerMockDate('freezeMockTime'))))), jsx(Row, null, jsx(Col, null, jsx(Button, {
    type: "submit"
  }, "Save")), jsx(Col, null, jsx(Button, {
    type: "button",
    onClick: onMockDateReset
  }, "Reset")))), jsx(Heading, {
    type: "h2"
  }, "Timezone"), jsx(Text, null, "Change your time zone. Enter a string in the format of a", ' ', jsx(Link, {
    href: "https://en.wikipedia.org/wiki/List_of_tz_database_time_zones",
    target: "_blank",
    rel: "noopener"
  }, "tz database name")), jsx("form", {
    onSubmit: handleSubmitMockTimezone(function (data) {
      onMockTimezoneSave && onMockTimezoneSave(data.mockTimezone);
    })
  }, jsx(Row, null, jsx(Col, null, jsx(Text, null, "Mock time zone:")), jsx(Col, null, jsx("select", _extends({
    defaultValue: defaultValueMockTimezone
  }, registerMockTimezone('mockTimezone', {
    required: true
  })), IanaTimezones$1.map(function (tz) {
    return jsx("option", {
      key: tz.name,
      value: tz.name
    }, tz.name);
  })))), jsx(Row, null, jsx(Col, null, jsx(Button, {
    type: "submit"
  }, "Save")), jsx(Col, null, jsx(Button, {
    type: "button",
    onClick: onMockTimezoneReset
  }, "Reset")))));
};
var Container = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ebz6gja2"
} : {
  target: "ebz6gja2",
  label: "Container"
})(process.env.NODE_ENV === "production" ? {
  name: "mzip8r",
  styles: "z-index:99999;color:white"
} : {
  name: "mzip8r",
  styles: "z-index:99999;color:white",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Row = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ebz6gja1"
} : {
  target: "ebz6gja1",
  label: "Row"
})(process.env.NODE_ENV === "production" ? {
  name: "61xwac",
  styles: "display:flex;padding:1rem 0"
} : {
  name: "61xwac",
  styles: "display:flex;padding:1rem 0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var Col = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "ebz6gja0"
} : {
  target: "ebz6gja0",
  label: "Col"
})(process.env.NODE_ENV === "production" ? {
  name: "1p1m5lf",
  styles: "display:flex;align-items:center;margin-right:10px"
} : {
  name: "1p1m5lf",
  styles: "display:flex;align-items:center;margin-right:10px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var FEATURE_FLAGS = 'featureFlags';
var withDebugMenuControls = function withDebugMenuControls(WrappedComponent, props) {
  var mockTime = LocalStorageUtil$1.get(MOCK_TIME);
  var isFreezeTimeChecked = mockTime ? !!mockTime.freezedMockDate : false;
  var _useModal = useModal(),
    _useModal2 = _slicedToArray(_useModal, 1),
    modalRef = _useModal2[0];
  useEffect(function () {
    function handlekeydownEvent(event) {
      var code = event.code,
        altKey = event.altKey;
      if (code === 'KeyD' && altKey || code === 'KeyT' && altKey) {
        var _modalRef$current;
        (_modalRef$current = modalRef.current) === null || _modalRef$current === void 0 || _modalRef$current.open();
      }
    }
    document.addEventListener('keyup', handlekeydownEvent);
    return function () {
      document.removeEventListener('keyup', handlekeydownEvent);
    };
  }, [modalRef.current]);
  return jsx(React.Fragment, null, jsx(DebugState, null), jsx(Modal, {
    ref: modalRef
  }, jsx(WrappedComponent, _extends({
    onMockDateSave: function onMockDateSave(mockDate) {
      LocalStorageUtil$1.remove(MOCK_TIME);
      LocalStorageUtil$1.set(MOCK_TIME, mockDate);
      location.reload();
    },
    onMockDateReset: function onMockDateReset() {
      LocalStorageUtil$1.remove(MOCK_TIME);
      location.reload();
    },
    defaultValueMockDateFreeze: isFreezeTimeChecked,
    defaultValueMockTimezone: TimeUtil.getUsersTimezone(),
    onMockTimezoneSave: function onMockTimezoneSave(timezone) {
      LocalStorageUtil$1.set(MOCK_TIME_ZONE, timezone);
      location.reload();
    },
    onMockTimezoneReset: function onMockTimezoneReset() {
      LocalStorageUtil$1.remove(MOCK_TIME_ZONE);
      location.reload();
    }
  }, props))));
};

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function mustache(string) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var delimiters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ['{{', '}}'];
  if (!string) return '';
  var _delimiters = _slicedToArray(delimiters, 2),
    startDelimiter = _delimiters[0],
    endDelimiter = _delimiters[1];
  function flattenObj(obj, parent) {
    var res = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    for (var key in obj) {
      var propName = parent ? parent + '.' + key : key;
      if (_typeof(obj[key]) == 'object' && obj[key] !== null) {
        flattenObj(obj[key], propName, res);
      } else {
        res[propName] = obj[key];
      }
    }
    return res;
  }
  return Object.entries(flattenObj(data)).reduce(function (res, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];
    return res.replace(new RegExp("".concat(escapeRegExp(startDelimiter), "\\s*").concat(key, "\\s*").concat(escapeRegExp(endDelimiter)), 'g'), String(value));
  }, string);
}
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

var useSSRCompatibleLayoutEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
var ReactPortal = function ReactPortal(props) {
  var children = props.children,
    _props$wrapperId = props.wrapperId,
    wrapperId = _props$wrapperId === void 0 ? 'react-portal-wrapper' : _props$wrapperId;
  var _React$useState = React.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    wrapperElement = _React$useState2[0],
    setWrapperElement = _React$useState2[1];
  useSSRCompatibleLayoutEffect(function () {
    var element = document.getElementById(wrapperId);
    var systemCreated = false;
    // if element is not found with wrapperId or wrapperId is not provided,
    // create and append to body
    if (!element) {
      systemCreated = true;
      element = createWrapperAndAppendToBody(wrapperId);
    }
    element.style.zIndex = '2000';
    element.style.position = 'absolute';
    setWrapperElement(element);
    return function () {
      var _element;
      // delete the programatically created element
      if (systemCreated && (_element = element) !== null && _element !== void 0 && _element.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }, [wrapperId]);

  // wrapperElement state will be null on the very first render.
  if (wrapperElement === null) return null;
  return /*#__PURE__*/createPortal(children, wrapperElement);
};
function createWrapperAndAppendToBody(wrapperId) {
  var wrapperElement = document.createElement('div');
  wrapperElement.setAttribute('id', wrapperId);
  document.body.appendChild(wrapperElement);
  return wrapperElement;
}

//export type TimezoneKey = keyof typeof IanaTimezones.map(({ name }) => name)

var IanaTimezones = [{
  name: 'Africa/Abidjan',
  utcOffset: 0,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'Africa/Accra',
  utcOffset: 0,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'Africa/Algiers',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Africa/Bissau',
  utcOffset: 0,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'Africa/Cairo',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Africa/Casablanca',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'Africa/Ceuta',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Africa/El_Aaiun',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'Africa/Johannesburg',
  utcOffset: 120,
  abbr: {
    en: {
      ndst: 'SAST',
      dst: 'SAST'
    },
    de: {
      ndst: 'SAST',
      dst: 'SAST'
    }
  }
}, {
  name: 'Africa/Juba',
  utcOffset: 180,
  abbr: {
    en: {
      ndst: 'CAT',
      dst: 'DST'
    },
    de: {
      ndst: 'CAT',
      dst: 'DST'
    }
  }
}, {
  name: 'Africa/Khartoum',
  utcOffset: 120,
  abbr: {
    en: {
      ndst: 'SAST',
      dst: 'SAST'
    },
    de: {
      ndst: 'SAST',
      dst: 'SAST'
    }
  }
}, {
  name: 'Africa/Lagos',
  utcOffset: 60,
  abbr: {
    en: {
      ndst: 'WAT',
      dst: 'WAST'
    },
    de: {
      ndst: 'WAT',
      dst: 'WAST'
    }
  }
}, {
  name: 'Africa/Maputo',
  utcOffset: 120,
  abbr: {
    en: {
      ndst: 'SAST',
      dst: 'SAST'
    },
    de: {
      ndst: 'SAST',
      dst: 'SAST'
    }
  }
}, {
  name: 'Africa/Monrovia',
  utcOffset: 0,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'Africa/Nairobi',
  utcOffset: 180,
  abbr: {
    en: {
      ndst: 'CAT',
      dst: 'DST'
    },
    de: {
      ndst: 'CAT',
      dst: 'DST'
    }
  }
}, {
  name: 'Africa/Ndjamena',
  utcOffset: 60,
  abbr: {
    en: {
      ndst: 'WAT',
      dst: 'WAST'
    },
    de: {
      ndst: 'WAT',
      dst: 'WAST'
    }
  }
}, {
  name: 'Africa/Sao_Tome',
  utcOffset: 0,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'Africa/Tripoli',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Africa/Tunis',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Africa/Windhoek',
  utcOffset: 120,
  abbr: {
    en: {
      ndst: 'SAST',
      dst: 'SAST'
    },
    de: {
      ndst: 'SAST',
      dst: 'SAST'
    }
  }
}, {
  name: 'America/Adak',
  utcOffset: -600,
  abbr: {
    en: {
      ndst: 'HAST',
      dst: 'HADT'
    },
    de: {
      ndst: 'HAST',
      dst: 'HADT'
    }
  }
}, {
  name: 'America/Anchorage',
  utcOffset: -540,
  abbr: {
    en: {
      ndst: 'AKST',
      dst: 'AKDT'
    },
    de: {
      ndst: 'AKST',
      dst: 'AKDT'
    }
  }
}, {
  name: 'America/Araguaina',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'SEST',
      dst: 'SEST'
    },
    de: {
      ndst: 'SEST',
      dst: 'SEST'
    }
  }
}, {
  name: 'America/Argentina/La_Rioja',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'AST'
    },
    de: {
      ndst: 'AST',
      dst: 'AST'
    }
  }
}, {
  name: 'America/Argentina/Rio_Gallegos',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'AST'
    },
    de: {
      ndst: 'AST',
      dst: 'AST'
    }
  }
}, {
  name: 'America/Argentina/Salta',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'AST'
    },
    de: {
      ndst: 'AST',
      dst: 'AST'
    }
  }
}, {
  name: 'America/Argentina/San_Juan',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'AST'
    },
    de: {
      ndst: 'AST',
      dst: 'AST'
    }
  }
}, {
  name: 'America/Argentina/San_Luis',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'AST'
    },
    de: {
      ndst: 'AST',
      dst: 'AST'
    }
  }
}, {
  name: 'America/Argentina/Tucuman',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'AST'
    },
    de: {
      ndst: 'AST',
      dst: 'AST'
    }
  }
}, {
  name: 'America/Argentina/Ushuaia',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'AST'
    },
    de: {
      ndst: 'AST',
      dst: 'AST'
    }
  }
}, {
  name: 'America/Asuncion',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'PYT',
      dst: 'PYT'
    },
    de: {
      ndst: 'PYT',
      dst: 'PYT'
    }
  }
}, {
  name: 'America/Bahia',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'BST',
      dst: 'BST'
    },
    de: {
      ndst: 'BST',
      dst: 'BST'
    }
  }
}, {
  name: 'America/Bahia_Banderas',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Barbados',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'ADT'
    },
    de: {
      ndst: 'AST',
      dst: 'ADT'
    }
  }
}, {
  name: 'America/Belem',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'SEST',
      dst: 'SEST'
    },
    de: {
      ndst: 'SEST',
      dst: 'SEST'
    }
  }
}, {
  name: 'America/Belize',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Blanc-Sablon',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'ADT'
    },
    de: {
      ndst: 'AST',
      dst: 'ADT'
    }
  }
}, {
  name: 'America/Boa_Vista',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'SWST',
      dst: 'SWST'
    },
    de: {
      ndst: 'SWST',
      dst: 'SWST'
    }
  }
}, {
  name: 'America/Bogota',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'SPST',
      dst: 'SPST'
    },
    de: {
      ndst: 'SPST',
      dst: 'SPST'
    }
  }
}, {
  name: 'America/Boise',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MDT'
    },
    de: {
      ndst: 'MST',
      dst: 'MDT'
    }
  }
}, {
  name: 'America/Cambridge_Bay',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MDT'
    },
    de: {
      ndst: 'MST',
      dst: 'MDT'
    }
  }
}, {
  name: 'America/Campo_Grande',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'CBST',
      dst: 'CBST'
    },
    de: {
      ndst: 'CBST',
      dst: 'CBST'
    }
  }
}, {
  name: 'America/Cancun',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Caracas',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'VST',
      dst: 'VST'
    },
    de: {
      ndst: 'VST',
      dst: 'VST'
    }
  }
}, {
  name: 'America/Cayenne',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'SEST',
      dst: 'SEST'
    },
    de: {
      ndst: 'SEST',
      dst: 'SEST'
    }
  }
}, {
  name: 'America/Chicago',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Chihuahua',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MDT',
      dst: 'MDT'
    },
    de: {
      ndst: 'MDT',
      dst: 'MDT'
    }
  }
}, {
  name: 'America/Costa_Rica',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Creston',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MDT'
    },
    de: {
      ndst: 'MST',
      dst: 'MDT'
    }
  }
}, {
  name: 'America/Cuiaba',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'CBST',
      dst: 'CBST'
    },
    de: {
      ndst: 'CBST',
      dst: 'CBST'
    }
  }
}, {
  name: 'America/Curacao',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'ADT'
    },
    de: {
      ndst: 'AST',
      dst: 'ADT'
    }
  }
}, {
  name: 'America/Danmarkshavn',
  utcOffset: 0,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'America/Dawson',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MDT'
    },
    de: {
      ndst: 'MST',
      dst: 'MDT'
    }
  }
}, {
  name: 'America/Dawson_Creek',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MDT'
    },
    de: {
      ndst: 'MST',
      dst: 'MDT'
    }
  }
}, {
  name: 'America/Denver',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MDT'
    },
    de: {
      ndst: 'MST',
      dst: 'MDT'
    }
  }
}, {
  name: 'America/Detroit',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Edmonton',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MDT'
    },
    de: {
      ndst: 'MST',
      dst: 'MDT'
    }
  }
}, {
  name: 'America/Eirunepe',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'SPST',
      dst: 'SPST'
    },
    de: {
      ndst: 'SPST',
      dst: 'SPST'
    }
  }
}, {
  name: 'America/El_Salvador',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Fort_Nelson',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MDT'
    },
    de: {
      ndst: 'MST',
      dst: 'MDT'
    }
  }
}, {
  name: 'America/Fortaleza',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'SEST',
      dst: 'SEST'
    },
    de: {
      ndst: 'SEST',
      dst: 'SEST'
    }
  }
}, {
  name: 'America/Glace_Bay',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'ADT'
    },
    de: {
      ndst: 'AST',
      dst: 'ADT'
    }
  }
}, {
  name: 'America/Goose_Bay',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'ADT'
    },
    de: {
      ndst: 'AST',
      dst: 'ADT'
    }
  }
}, {
  name: 'America/Grand_Turk',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Guatemala',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Guayaquil',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'SPST',
      dst: 'SPST'
    },
    de: {
      ndst: 'SPST',
      dst: 'SPST'
    }
  }
}, {
  name: 'America/Guyana',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'UTC-4',
      dst: 'UTC-4'
    },
    de: {
      ndst: 'UTC-4',
      dst: 'UTC-4'
    }
  }
}, {
  name: 'America/Halifax',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'ADT'
    },
    de: {
      ndst: 'AST',
      dst: 'ADT'
    }
  }
}, {
  name: 'America/Havana',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EDT',
      dst: 'EDT'
    },
    de: {
      ndst: 'EDT',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Hermosillo',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'UMST',
      dst: 'UMST'
    },
    de: {
      ndst: 'UMST',
      dst: 'UMST'
    }
  }
}, {
  name: 'America/Indiana/Knox',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Indiana/Marengo',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Indiana/Petersburg',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Indiana/Tell_City',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Indiana/Vevay',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Indiana/Vincennes',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Indiana/Winamac',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Inuvik',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MDT'
    },
    de: {
      ndst: 'MST',
      dst: 'MDT'
    }
  }
}, {
  name: 'America/Iqaluit',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Jamaica',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Juneau',
  utcOffset: -540,
  abbr: {
    en: {
      ndst: 'AKST',
      dst: 'AKDT'
    },
    de: {
      ndst: 'AKST',
      dst: 'AKDT'
    }
  }
}, {
  name: 'America/Kentucky/Monticello',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/La_Paz',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'SWST',
      dst: 'SWST'
    },
    de: {
      ndst: 'SWST',
      dst: 'SWST'
    }
  }
}, {
  name: 'America/Lima',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'SPST',
      dst: 'SPST'
    },
    de: {
      ndst: 'SPST',
      dst: 'SPST'
    }
  }
}, {
  name: 'America/Los_Angeles',
  utcOffset: -480,
  abbr: {
    en: {
      ndst: 'PST',
      dst: 'PDT'
    },
    de: {
      ndst: 'PST',
      dst: 'PDT'
    }
  }
}, {
  name: 'America/Maceio',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'SEST',
      dst: 'SEST'
    },
    de: {
      ndst: 'SEST',
      dst: 'SEST'
    }
  }
}, {
  name: 'America/Managua',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Manaus',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'SWST',
      dst: 'SWST'
    },
    de: {
      ndst: 'SWST',
      dst: 'SWST'
    }
  }
}, {
  name: 'America/Martinique',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'ADT'
    },
    de: {
      ndst: 'AST',
      dst: 'ADT'
    }
  }
}, {
  name: 'America/Matamoros',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Mazatlan',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MDT',
      dst: 'MDT'
    },
    de: {
      ndst: 'MDT',
      dst: 'MDT'
    }
  }
}, {
  name: 'America/Menominee',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Merida',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Metlakatla',
  utcOffset: -540,
  abbr: {
    en: {
      ndst: 'AKST',
      dst: 'AKDT'
    },
    de: {
      ndst: 'AKST',
      dst: 'AKDT'
    }
  }
}, {
  name: 'America/Mexico_City',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Miquelon',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: '',
      dst: ''
    },
    de: {
      ndst: '',
      dst: ''
    }
  }
}, {
  name: 'America/Moncton',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'ADT'
    },
    de: {
      ndst: 'AST',
      dst: 'ADT'
    }
  }
}, {
  name: 'America/Monterrey',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Montevideo',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MST'
    },
    de: {
      ndst: 'MST',
      dst: 'MST'
    }
  }
}, {
  name: 'America/Nassau',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/New_York',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Nipigon',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Nome',
  utcOffset: -540,
  abbr: {
    en: {
      ndst: 'AKST',
      dst: 'AKDT'
    },
    de: {
      ndst: 'AKST',
      dst: 'AKDT'
    }
  }
}, {
  name: 'America/Noronha',
  utcOffset: -120,
  abbr: {
    en: {
      ndst: 'U',
      dst: 'U'
    },
    de: {
      ndst: 'U',
      dst: 'U'
    }
  }
}, {
  name: 'America/North_Dakota/Beulah',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/North_Dakota/Center',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/North_Dakota/New_Salem',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Ojinaga',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MDT'
    },
    de: {
      ndst: 'MST',
      dst: 'MDT'
    }
  }
}, {
  name: 'America/Panama',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Pangnirtung',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Paramaribo',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'SEST',
      dst: 'SEST'
    },
    de: {
      ndst: 'SEST',
      dst: 'SEST'
    }
  }
}, {
  name: 'America/Phoenix',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MDT'
    },
    de: {
      ndst: 'MST',
      dst: 'MDT'
    }
  }
}, {
  name: 'America/Port-au-Prince',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Port_of_Spain',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'ADT'
    },
    de: {
      ndst: 'AST',
      dst: 'ADT'
    }
  }
}, {
  name: 'America/Porto_Velho',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'SWST',
      dst: 'SWST'
    },
    de: {
      ndst: 'SWST',
      dst: 'SWST'
    }
  }
}, {
  name: 'America/Puerto_Rico',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'ADT'
    },
    de: {
      ndst: 'AST',
      dst: 'ADT'
    }
  }
}, {
  name: 'America/Punta_Arenas',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: '',
      dst: ''
    },
    de: {
      ndst: '',
      dst: ''
    }
  }
}, {
  name: 'America/Rainy_River',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Rankin_Inlet',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Recife',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'SEST',
      dst: 'SEST'
    },
    de: {
      ndst: 'SEST',
      dst: 'SEST'
    }
  }
}, {
  name: 'America/Regina',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Resolute',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Rio_Branco',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'SPST',
      dst: 'SPST'
    },
    de: {
      ndst: 'SPST',
      dst: 'SPST'
    }
  }
}, {
  name: 'America/Santarem',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'SEST',
      dst: 'SEST'
    },
    de: {
      ndst: 'SEST',
      dst: 'SEST'
    }
  }
}, {
  name: 'America/Santiago',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'PSST',
      dst: 'PSST'
    },
    de: {
      ndst: 'PSST',
      dst: 'PSST'
    }
  }
}, {
  name: 'America/Santo_Domingo',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'ADT'
    },
    de: {
      ndst: 'AST',
      dst: 'ADT'
    }
  }
}, {
  name: 'America/Sao_Paulo',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'ESAST',
      dst: 'ESAST'
    },
    de: {
      ndst: 'ESAST',
      dst: 'ESAST'
    }
  }
}, {
  name: 'America/Scoresbysund',
  utcOffset: -60,
  abbr: {
    en: {
      ndst: 'ADT',
      dst: 'ADT'
    },
    de: {
      ndst: 'ADT',
      dst: 'ADT'
    }
  }
}, {
  name: 'America/Sitka',
  utcOffset: -540,
  abbr: {
    en: {
      ndst: 'AKST',
      dst: 'AKDT'
    },
    de: {
      ndst: 'AKST',
      dst: 'AKDT'
    }
  }
}, {
  name: 'America/St_Johns',
  utcOffset: -210,
  abbr: {
    en: {
      ndst: 'NST',
      dst: 'NDT'
    },
    de: {
      ndst: 'NST',
      dst: 'NDT'
    }
  }
}, {
  name: 'America/Swift_Current',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Tegucigalpa',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Thule',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'ADT'
    },
    de: {
      ndst: 'AST',
      dst: 'ADT'
    }
  }
}, {
  name: 'America/Thunder_Bay',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Tijuana',
  utcOffset: -480,
  abbr: {
    en: {
      ndst: 'PST',
      dst: 'PDT'
    },
    de: {
      ndst: 'PST',
      dst: 'PDT'
    }
  }
}, {
  name: 'America/Toronto',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'America/Vancouver',
  utcOffset: -480,
  abbr: {
    en: {
      ndst: 'PST',
      dst: 'PDT'
    },
    de: {
      ndst: 'PST',
      dst: 'PDT'
    }
  }
}, {
  name: 'America/Whitehorse',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MDT'
    },
    de: {
      ndst: 'MST',
      dst: 'MDT'
    }
  }
}, {
  name: 'America/Winnipeg',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'America/Yakutat',
  utcOffset: -540,
  abbr: {
    en: {
      ndst: 'AKST',
      dst: 'AKDT'
    },
    de: {
      ndst: 'AKST',
      dst: 'AKDT'
    }
  }
}, {
  name: 'America/Yellowknife',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MDT'
    },
    de: {
      ndst: 'MST',
      dst: 'MDT'
    }
  }
}, {
  name: 'Antarctica/Casey',
  utcOffset: 660,
  abbr: {
    en: {
      ndst: 'WAST',
      dst: 'WAST'
    },
    de: {
      ndst: 'WAST',
      dst: 'WAST'
    }
  }
}, {
  name: 'Antarctica/Davis',
  utcOffset: 420,
  abbr: {
    en: {
      ndst: 'SAST',
      dst: 'SAST'
    },
    de: {
      ndst: 'SAST',
      dst: 'SAST'
    }
  }
}, {
  name: 'Antarctica/DumontDUrville',
  utcOffset: 600,
  abbr: {
    en: {
      ndst: 'WPST',
      dst: 'WPST'
    },
    de: {
      ndst: 'WPST',
      dst: 'WPST'
    }
  }
}, {
  name: 'Antarctica/Macquarie',
  utcOffset: 660,
  abbr: {
    en: {
      ndst: 'AEST',
      dst: 'AEDT'
    },
    de: {
      ndst: 'AEST',
      dst: 'AEDT'
    }
  }
}, {
  name: 'Antarctica/Mawson',
  utcOffset: 300,
  abbr: {
    en: {
      ndst: 'WAST',
      dst: 'WAST'
    },
    de: {
      ndst: 'WAST',
      dst: 'WAST'
    }
  }
}, {
  name: 'Antarctica/Palmer',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'PSST',
      dst: 'PSST'
    },
    de: {
      ndst: 'PSST',
      dst: 'PSST'
    }
  }
}, {
  name: 'Antarctica/Rothera',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'SEST',
      dst: 'SEST'
    },
    de: {
      ndst: 'SEST',
      dst: 'SEST'
    }
  }
}, {
  name: 'Antarctica/Syowa',
  utcOffset: 180,
  abbr: {
    en: {
      ndst: 'EAST',
      dst: 'EAST'
    },
    de: {
      ndst: 'EAST',
      dst: 'EAST'
    }
  }
}, {
  name: 'Antarctica/Troll',
  utcOffset: 0,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'Antarctica/Vostok',
  utcOffset: 360,
  abbr: {
    en: {
      ndst: 'CAST',
      dst: 'CAST'
    },
    de: {
      ndst: 'CAST',
      dst: 'CAST'
    }
  }
}, {
  name: 'Asia/Almaty',
  utcOffset: 360,
  abbr: {
    en: {
      ndst: 'CAST',
      dst: 'CAST'
    },
    de: {
      ndst: 'CAST',
      dst: 'CAST'
    }
  }
}, {
  name: 'Asia/Amman',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Asia/Anadyr',
  utcOffset: 720,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MST'
    },
    de: {
      ndst: 'MST',
      dst: 'MST'
    }
  }
}, {
  name: 'Asia/Aqtau',
  utcOffset: 300,
  abbr: {
    en: {
      ndst: 'WAST',
      dst: 'WAST'
    },
    de: {
      ndst: 'WAST',
      dst: 'WAST'
    }
  }
}, {
  name: 'Asia/Aqtobe',
  utcOffset: 300,
  abbr: {
    en: {
      ndst: 'WAST',
      dst: 'WAST'
    },
    de: {
      ndst: 'WAST',
      dst: 'WAST'
    }
  }
}, {
  name: 'Asia/Ashgabat',
  utcOffset: 300,
  abbr: {
    en: {
      ndst: 'WAST',
      dst: 'WAST'
    },
    de: {
      ndst: 'WAST',
      dst: 'WAST'
    }
  }
}, {
  name: 'Asia/Atyrau',
  utcOffset: 300,
  abbr: {
    en: {
      ndst: '',
      dst: ''
    },
    de: {
      ndst: '',
      dst: ''
    }
  }
}, {
  name: 'Asia/Baghdad',
  utcOffset: 180,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'AST'
    },
    de: {
      ndst: 'AST',
      dst: 'AST'
    }
  }
}, {
  name: 'Asia/Baku',
  utcOffset: 240,
  abbr: {
    en: {
      ndst: 'ADT',
      dst: 'ADT'
    },
    de: {
      ndst: 'ADT',
      dst: 'ADT'
    }
  }
}, {
  name: 'Asia/Bangkok',
  utcOffset: 420,
  abbr: {
    en: {
      ndst: 'SAST',
      dst: 'SAST'
    },
    de: {
      ndst: 'SAST',
      dst: 'SAST'
    }
  }
}, {
  name: 'Asia/Barnaul',
  utcOffset: 420,
  abbr: {
    en: {
      ndst: '',
      dst: ''
    },
    de: {
      ndst: '',
      dst: ''
    }
  }
}, {
  name: 'Asia/Beirut',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Asia/Bishkek',
  utcOffset: 360,
  abbr: {
    en: {
      ndst: 'CAST',
      dst: 'CAST'
    },
    de: {
      ndst: 'CAST',
      dst: 'CAST'
    }
  }
}, {
  name: 'Asia/Brunei',
  utcOffset: 480,
  abbr: {
    en: {
      ndst: 'MPST',
      dst: 'MPST'
    },
    de: {
      ndst: 'MPST',
      dst: 'MPST'
    }
  }
}, {
  name: 'Asia/Chita',
  utcOffset: 540,
  abbr: {
    en: {
      ndst: 'YST',
      dst: 'YST'
    },
    de: {
      ndst: 'YST',
      dst: 'YST'
    }
  }
}, {
  name: 'Asia/Choibalsan',
  utcOffset: 480,
  abbr: {
    en: {
      ndst: 'UST',
      dst: 'UST'
    },
    de: {
      ndst: 'UST',
      dst: 'UST'
    }
  }
}, {
  name: 'Asia/Colombo',
  utcOffset: 330,
  abbr: {
    en: {
      ndst: 'UTC+5:30',
      dst: 'UTC+5:30'
    },
    de: {
      ndst: 'UTC+5:30',
      dst: 'UTC+5:30'
    }
  }
}, {
  name: 'Asia/Damascus',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Asia/Dhaka',
  utcOffset: 360,
  abbr: {
    en: {
      ndst: 'BST',
      dst: 'BST'
    },
    de: {
      ndst: 'BST',
      dst: 'BST'
    }
  }
}, {
  name: 'Asia/Dili',
  utcOffset: 540,
  abbr: {
    en: {
      ndst: 'JST',
      dst: 'JST'
    },
    de: {
      ndst: 'JST',
      dst: 'JST'
    }
  }
}, {
  name: 'Asia/Dubai',
  utcOffset: 240,
  abbr: {
    en: {
      ndst: 'UTC+4',
      dst: 'UTC+4'
    },
    de: {
      ndst: 'UTC+4',
      dst: 'UTC+4'
    }
  }
}, {
  name: 'Asia/Dushanbe',
  utcOffset: 300,
  abbr: {
    en: {
      ndst: 'WAST',
      dst: 'WAST'
    },
    de: {
      ndst: 'WAST',
      dst: 'WAST'
    }
  }
}, {
  name: 'Asia/Famagusta',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Asia/Gaza',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Asia/Hebron',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Asia/Hong_Kong',
  utcOffset: 480,
  abbr: {
    en: {
      ndst: 'HKT',
      dst: 'HKST'
    },
    de: {
      ndst: 'HKT',
      dst: 'HKST'
    }
  }
}, {
  name: 'Asia/Hovd',
  utcOffset: 420,
  abbr: {
    en: {
      ndst: 'SAST',
      dst: 'SAST'
    },
    de: {
      ndst: 'SAST',
      dst: 'SAST'
    }
  }
}, {
  name: 'Asia/Irkutsk',
  utcOffset: 480,
  abbr: {
    en: {
      ndst: 'NAEST',
      dst: 'NAEST'
    },
    de: {
      ndst: 'NAEST',
      dst: 'NAEST'
    }
  }
}, {
  name: 'Asia/Jakarta',
  utcOffset: 420,
  abbr: {
    en: {
      ndst: 'SAST',
      dst: 'SAST'
    },
    de: {
      ndst: 'SAST',
      dst: 'SAST'
    }
  }
}, {
  name: 'Asia/Jayapura',
  utcOffset: 540,
  abbr: {
    en: {
      ndst: 'JST',
      dst: 'JST'
    },
    de: {
      ndst: 'JST',
      dst: 'JST'
    }
  }
}, {
  name: 'Asia/Jerusalem',
  utcOffset: 120,
  abbr: {
    en: {
      ndst: 'JDT',
      dst: 'JDT'
    },
    de: {
      ndst: 'JDT',
      dst: 'JDT'
    }
  }
}, {
  name: 'Asia/Kabul',
  utcOffset: 270,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'AST'
    },
    de: {
      ndst: 'AST',
      dst: 'AST'
    }
  }
}, {
  name: 'Asia/Kamchatka',
  utcOffset: 720,
  abbr: {
    en: {
      ndst: 'KDT',
      dst: 'KDT'
    },
    de: {
      ndst: 'KDT',
      dst: 'KDT'
    }
  }
}, {
  name: 'Asia/Karachi',
  utcOffset: 300,
  abbr: {
    en: {
      ndst: 'PKT',
      dst: 'PKT'
    },
    de: {
      ndst: 'PKT',
      dst: 'PKT'
    }
  }
}, {
  name: 'Asia/Khandyga',
  utcOffset: 540,
  abbr: {
    en: {
      ndst: 'YST',
      dst: 'YST'
    },
    de: {
      ndst: 'YST',
      dst: 'YST'
    }
  }
}, {
  name: 'Asia/Kolkata',
  utcOffset: 330,
  abbr: {
    en: {
      ndst: 'IST',
      dst: 'IST'
    },
    de: {
      ndst: 'IST',
      dst: 'IST'
    }
  }
}, {
  name: 'Asia/Calcutta',
  utcOffset: 330,
  abbr: {
    en: {
      ndst: 'IST',
      dst: 'IST'
    },
    de: {
      ndst: 'IST',
      dst: 'IST'
    }
  }
}, {
  name: 'Asia/Krasnoyarsk',
  utcOffset: 420,
  abbr: {
    en: {
      ndst: 'NAST',
      dst: 'NAST'
    },
    de: {
      ndst: 'NAST',
      dst: 'NAST'
    }
  }
}, {
  name: 'Asia/Kuala_Lumpur',
  utcOffset: 480,
  abbr: {
    en: {
      ndst: 'UTC+8',
      dst: 'UTC+8'
    },
    de: {
      ndst: 'UTC+8',
      dst: 'UTC+8'
    }
  }
}, {
  name: 'Asia/Kuching',
  utcOffset: 480,
  abbr: {
    en: {
      ndst: 'UTC+8',
      dst: 'UTC+8'
    },
    de: {
      ndst: 'UTC+8',
      dst: 'UTC+8'
    }
  }
}, {
  name: 'Asia/Macau',
  utcOffset: 480,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CST'
    },
    de: {
      ndst: 'CST',
      dst: 'CST'
    }
  }
}, {
  name: 'Asia/Magadan',
  utcOffset: 660,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MST'
    },
    de: {
      ndst: 'MST',
      dst: 'MST'
    }
  }
}, {
  name: 'Asia/Makassar',
  utcOffset: 480,
  abbr: {
    en: {
      ndst: 'MPST',
      dst: 'MPST'
    },
    de: {
      ndst: 'MPST',
      dst: 'MPST'
    }
  }
}, {
  name: 'Asia/Manila',
  utcOffset: 480,
  abbr: {
    en: {
      ndst: 'MPST',
      dst: 'MPST'
    },
    de: {
      ndst: 'MPST',
      dst: 'MPST'
    }
  }
}, {
  name: 'Asia/Nicosia',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Asia/Novokuznetsk',
  utcOffset: 420,
  abbr: {
    en: {
      ndst: 'NCAST',
      dst: 'NCAST'
    },
    de: {
      ndst: 'NCAST',
      dst: 'NCAST'
    }
  }
}, {
  name: 'Asia/Novosibirsk',
  utcOffset: 420,
  abbr: {
    en: {
      ndst: 'NCAST',
      dst: 'NCAST'
    },
    de: {
      ndst: 'NCAST',
      dst: 'NCAST'
    }
  }
}, {
  name: 'Asia/Omsk',
  utcOffset: 360,
  abbr: {
    en: {
      ndst: 'NCAST',
      dst: 'NCAST'
    },
    de: {
      ndst: 'NCAST',
      dst: 'NCAST'
    }
  }
}, {
  name: 'Asia/Oral',
  utcOffset: 300,
  abbr: {
    en: {
      ndst: 'WAST',
      dst: 'WAST'
    },
    de: {
      ndst: 'WAST',
      dst: 'WAST'
    }
  }
}, {
  name: 'Asia/Pontianak',
  utcOffset: 420,
  abbr: {
    en: {
      ndst: 'SAST',
      dst: 'SAST'
    },
    de: {
      ndst: 'SAST',
      dst: 'SAST'
    }
  }
}, {
  name: 'Asia/Pyongyang',
  utcOffset: 540,
  abbr: {
    en: {
      ndst: 'KST',
      dst: 'KST'
    },
    de: {
      ndst: 'KST',
      dst: 'KST'
    }
  }
}, {
  name: 'Asia/Qatar',
  utcOffset: 180,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'AST'
    },
    de: {
      ndst: 'AST',
      dst: 'AST'
    }
  }
}, {
  name: 'Asia/Qostanay',
  utcOffset: 360,
  abbr: {
    en: {
      ndst: '',
      dst: ''
    },
    de: {
      ndst: '',
      dst: ''
    }
  }
}, {
  name: 'Asia/Qyzylorda',
  utcOffset: 300,
  abbr: {
    en: {
      ndst: 'CAST',
      dst: 'CAST'
    },
    de: {
      ndst: 'CAST',
      dst: 'CAST'
    }
  }
}, {
  name: 'Asia/Riyadh',
  utcOffset: 180,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'AST'
    },
    de: {
      ndst: 'AST',
      dst: 'AST'
    }
  }
}, {
  name: 'Asia/Sakhalin',
  utcOffset: 660,
  abbr: {
    en: {
      ndst: 'VST',
      dst: 'VST'
    },
    de: {
      ndst: 'VST',
      dst: 'VST'
    }
  }
}, {
  name: 'Asia/Samarkand',
  utcOffset: 300,
  abbr: {
    en: {
      ndst: 'WAST',
      dst: 'WAST'
    },
    de: {
      ndst: 'WAST',
      dst: 'WAST'
    }
  }
}, {
  name: 'Asia/Seoul',
  utcOffset: 540,
  abbr: {
    en: {
      ndst: 'KST',
      dst: 'KST'
    },
    de: {
      ndst: 'KST',
      dst: 'KST'
    }
  }
}, {
  name: 'Asia/Shanghai',
  utcOffset: 480,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CST'
    },
    de: {
      ndst: 'CST',
      dst: 'CST'
    }
  }
}, {
  name: 'Asia/Singapore',
  utcOffset: 480,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CST'
    },
    de: {
      ndst: 'CST',
      dst: 'CST'
    }
  }
}, {
  name: 'Asia/Srednekolymsk',
  utcOffset: 660,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MST'
    },
    de: {
      ndst: 'MST',
      dst: 'MST'
    }
  }
}, {
  name: 'Asia/Taipei',
  utcOffset: 480,
  abbr: {
    en: {
      ndst: 'TST',
      dst: 'TST'
    },
    de: {
      ndst: 'TST',
      dst: 'TST'
    }
  }
}, {
  name: 'Asia/Tashkent',
  utcOffset: 300,
  abbr: {
    en: {
      ndst: 'WAST',
      dst: 'WAST'
    },
    de: {
      ndst: 'WAST',
      dst: 'WAST'
    }
  }
}, {
  name: 'Asia/Tbilisi',
  utcOffset: 240,
  abbr: {
    en: {
      ndst: 'GET',
      dst: 'GET'
    },
    de: {
      ndst: 'GET',
      dst: 'GET'
    }
  }
}, {
  name: 'Asia/Tehran',
  utcOffset: 210,
  abbr: {
    en: {
      ndst: 'IDT',
      dst: 'IDT'
    },
    de: {
      ndst: 'IDT',
      dst: 'IDT'
    }
  }
}, {
  name: 'Asia/Thimphu',
  utcOffset: 360,
  abbr: {
    en: {
      ndst: 'BST',
      dst: 'BST'
    },
    de: {
      ndst: 'BST',
      dst: 'BST'
    }
  }
}, {
  name: 'Asia/Tokyo',
  utcOffset: 540,
  abbr: {
    en: {
      ndst: 'JST',
      dst: 'JST'
    },
    de: {
      ndst: 'JST',
      dst: 'JST'
    }
  }
}, {
  name: 'Asia/Tomsk',
  utcOffset: 420,
  abbr: {
    en: {
      ndst: '',
      dst: ''
    },
    de: {
      ndst: '',
      dst: ''
    }
  }
}, {
  name: 'Asia/Ulaanbaatar',
  utcOffset: 480,
  abbr: {
    en: {
      ndst: 'UST',
      dst: 'UST'
    },
    de: {
      ndst: 'UST',
      dst: 'UST'
    }
  }
}, {
  name: 'Asia/Urumqi',
  utcOffset: 360,
  abbr: {
    en: {
      ndst: 'CAST',
      dst: 'CAST'
    },
    de: {
      ndst: 'CAST',
      dst: 'CAST'
    }
  }
}, {
  name: 'Asia/Ust-Nera',
  utcOffset: 600,
  abbr: {
    en: {
      ndst: 'VST',
      dst: 'VST'
    },
    de: {
      ndst: 'VST',
      dst: 'VST'
    }
  }
}, {
  name: 'Asia/Vladivostok',
  utcOffset: 600,
  abbr: {
    en: {
      ndst: 'VST',
      dst: 'VST'
    },
    de: {
      ndst: 'VST',
      dst: 'VST'
    }
  }
}, {
  name: 'Asia/Yakutsk',
  utcOffset: 540,
  abbr: {
    en: {
      ndst: 'YST',
      dst: 'YST'
    },
    de: {
      ndst: 'YST',
      dst: 'YST'
    }
  }
}, {
  name: 'Asia/Yekaterinburg',
  utcOffset: 300,
  abbr: {
    en: {
      ndst: 'YEKT',
      dst: 'YEKT'
    },
    de: {
      ndst: 'YEKT',
      dst: 'YEKT'
    }
  }
}, {
  name: 'Asia/Yerevan',
  utcOffset: 240,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CST'
    },
    de: {
      ndst: 'CST',
      dst: 'CST'
    }
  }
}, {
  name: 'Atlantic/Azores',
  utcOffset: -60,
  abbr: {
    en: {
      ndst: 'ADT',
      dst: 'ADT'
    },
    de: {
      ndst: 'ADT',
      dst: 'ADT'
    }
  }
}, {
  name: 'Atlantic/Bermuda',
  utcOffset: -240,
  abbr: {
    en: {
      ndst: 'AST',
      dst: 'ADT'
    },
    de: {
      ndst: 'AST',
      dst: 'ADT'
    }
  }
}, {
  name: 'Atlantic/Canary',
  utcOffset: 0,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'Atlantic/Cape_Verde',
  utcOffset: -60,
  abbr: {
    en: {
      ndst: 'CVST',
      dst: 'CVST'
    },
    de: {
      ndst: 'CVST',
      dst: 'CVST'
    }
  }
}, {
  name: 'Atlantic/Madeira',
  utcOffset: 0,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'Atlantic/Reykjavik',
  utcOffset: 0,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'Atlantic/South_Georgia',
  utcOffset: -120,
  abbr: {
    en: {
      ndst: 'U',
      dst: 'U'
    },
    de: {
      ndst: 'U',
      dst: 'U'
    }
  }
}, {
  name: 'Atlantic/Stanley',
  utcOffset: -180,
  abbr: {
    en: {
      ndst: 'SEST',
      dst: 'SEST'
    },
    de: {
      ndst: 'SEST',
      dst: 'SEST'
    }
  }
}, {
  name: 'Australia/Adelaide',
  utcOffset: 630,
  abbr: {
    en: {
      ndst: 'ACST',
      dst: 'ACDT'
    },
    de: {
      ndst: 'ACST',
      dst: 'ACDT'
    }
  }
}, {
  name: 'Australia/Brisbane',
  utcOffset: 600,
  abbr: {
    en: {
      ndst: 'AEST',
      dst: 'AEDT'
    },
    de: {
      ndst: 'AEST',
      dst: 'AEDT'
    }
  }
}, {
  name: 'Australia/Broken_Hill',
  utcOffset: 630,
  abbr: {
    en: {
      ndst: 'ACST',
      dst: 'ACDT'
    },
    de: {
      ndst: 'ACST',
      dst: 'ACDT'
    }
  }
}, {
  name: 'Australia/Darwin',
  utcOffset: 570,
  abbr: {
    en: {
      ndst: 'ACST',
      dst: 'ACDT'
    },
    de: {
      ndst: 'ACST',
      dst: 'ACDT'
    }
  }
}, {
  name: 'Australia/Eucla',
  utcOffset: 525,
  abbr: {
    en: {
      ndst: 'ACWST',
      dst: 'ACWDT'
    },
    de: {
      ndst: 'ACWST',
      dst: 'ACWDT'
    }
  }
}, {
  name: 'Australia/Hobart',
  utcOffset: 660,
  abbr: {
    en: {
      ndst: 'AEST',
      dst: 'AEDT'
    },
    de: {
      ndst: 'AEST',
      dst: 'AEDT'
    }
  }
}, {
  name: 'Australia/Lindeman',
  utcOffset: 600,
  abbr: {
    en: {
      ndst: 'AEST',
      dst: 'AEDT'
    },
    de: {
      ndst: 'AEST',
      dst: 'AEDT'
    }
  }
}, {
  name: 'Australia/Lord_Howe',
  utcOffset: 660,
  abbr: {
    en: {
      ndst: 'LHST',
      dst: 'LHDT'
    },
    de: {
      ndst: 'LHST',
      dst: 'LHDT'
    }
  }
}, {
  name: 'Australia/Melbourne',
  utcOffset: 660,
  abbr: {
    en: {
      ndst: 'AEST',
      dst: 'AEDT'
    },
    de: {
      ndst: 'AEST',
      dst: 'AEDT'
    }
  }
}, {
  name: 'Australia/Perth',
  utcOffset: 480,
  abbr: {
    en: {
      ndst: 'AWST',
      dst: 'AWDT'
    },
    de: {
      ndst: 'AWST',
      dst: 'AWDT'
    }
  }
}, {
  name: 'Australia/Sydney',
  utcOffset: 660,
  abbr: {
    en: {
      ndst: 'AEST',
      dst: 'AEDT'
    },
    de: {
      ndst: 'AEST',
      dst: 'AEDT'
    }
  }
}, {
  name: 'CST6CDT',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CST',
      dst: 'CDT'
    },
    de: {
      ndst: 'CST',
      dst: 'CDT'
    }
  }
}, {
  name: 'EST5EDT',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: 'EST',
      dst: 'EDT'
    },
    de: {
      ndst: 'EST',
      dst: 'EDT'
    }
  }
}, {
  name: 'Europe/Amsterdam',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Andorra',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Astrakhan',
  utcOffset: 240,
  abbr: {
    en: {
      ndst: 'SAMT',
      dst: 'SAMT'
    },
    de: {
      ndst: 'SAMT',
      dst: 'SAMT'
    }
  }
}, {
  name: 'Europe/Athens',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Europe/Belgrade',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Berlin',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Brussels',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Bucharest',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Europe/Budapest',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Chisinau',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Europe/Copenhagen',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Dublin',
  utcOffset: 0,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'Europe/Gibraltar',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Helsinki',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Europe/Istanbul',
  utcOffset: 180,
  abbr: {
    en: {
      ndst: 'TDT',
      dst: 'TDT'
    },
    de: {
      ndst: 'TDT',
      dst: 'TDT'
    }
  }
}, {
  name: 'Europe/Kaliningrad',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Europe/Kiev',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Europe/Kirov',
  utcOffset: 180,
  abbr: {
    en: {
      ndst: 'MSK',
      dst: 'MSK'
    },
    de: {
      ndst: 'MSK',
      dst: 'MSK'
    }
  }
}, {
  name: 'Europe/Lisbon',
  utcOffset: 0,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'Europe/London',
  utcOffset: 0,
  abbr: {
    de: {
      ndst: 'WEZ',
      dst: 'WESZ'
    },
    en: {
      ndst: 'WET',
      dst: 'WEST'
    }
  }
}, {
  name: 'Europe/Luxembourg',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Madrid',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Malta',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Minsk',
  utcOffset: 180,
  abbr: {
    en: {
      ndst: 'MSK',
      dst: 'MSK'
    },
    de: {
      ndst: 'MSK',
      dst: 'MSK'
    }
  }
}, {
  name: 'Europe/Monaco',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Moscow',
  utcOffset: 180,
  abbr: {
    en: {
      ndst: 'MSK',
      dst: 'MSK'
    },
    de: {
      ndst: 'MSK',
      dst: 'MSK'
    }
  }
}, {
  name: 'Europe/Oslo',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Paris',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Prague',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Riga',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Europe/Rome',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Samara',
  utcOffset: 240,
  abbr: {
    en: {
      ndst: 'SAMT',
      dst: 'SAMT'
    },
    de: {
      ndst: 'SAMT',
      dst: 'SAMT'
    }
  }
}, {
  name: 'Europe/Saratov',
  utcOffset: 240,
  abbr: {
    en: {
      ndst: '',
      dst: ''
    },
    de: {
      ndst: '',
      dst: ''
    }
  }
}, {
  name: 'Europe/Simferopol',
  utcOffset: 180,
  abbr: {
    en: {
      ndst: 'MSK',
      dst: 'MSK'
    },
    de: {
      ndst: 'MSK',
      dst: 'MSK'
    }
  }
}, {
  name: 'Europe/Sofia',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Europe/Stockholm',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Tallinn',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Europe/Tirane',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Ulyanovsk',
  utcOffset: 240,
  abbr: {
    en: {
      ndst: 'SAMT',
      dst: 'SAMT'
    },
    de: {
      ndst: 'SAMT',
      dst: 'SAMT'
    }
  }
}, {
  name: 'Europe/Uzhgorod',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Europe/Vienna',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Vilnius',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Europe/Volgograd',
  utcOffset: 240,
  abbr: {
    en: {
      ndst: 'MSK',
      dst: 'MSK'
    },
    de: {
      ndst: 'MSK',
      dst: 'MSK'
    }
  }
}, {
  name: 'Europe/Warsaw',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Europe/Zaporozhye',
  utcOffset: 120,
  abbr: {
    de: {
      ndst: 'OEZ',
      dst: 'OESZ'
    },
    en: {
      ndst: 'EET',
      dst: 'EEST'
    }
  }
}, {
  name: 'Europe/Zurich',
  utcOffset: 60,
  abbr: {
    de: {
      ndst: 'MEZ',
      dst: 'MESZ'
    },
    en: {
      ndst: 'CET',
      dst: 'CEST'
    }
  }
}, {
  name: 'Indian/Chagos',
  utcOffset: 360,
  abbr: {
    en: {
      ndst: 'CAST',
      dst: 'CAST'
    },
    de: {
      ndst: 'CAST',
      dst: 'CAST'
    }
  }
}, {
  name: 'Indian/Christmas',
  utcOffset: 420,
  abbr: {
    en: {
      ndst: 'SAST',
      dst: 'SAST'
    },
    de: {
      ndst: 'SAST',
      dst: 'SAST'
    }
  }
}, {
  name: 'Indian/Cocos',
  utcOffset: 390,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MST'
    },
    de: {
      ndst: 'MST',
      dst: 'MST'
    }
  }
}, {
  name: 'Indian/Kerguelen',
  utcOffset: 300,
  abbr: {
    en: {
      ndst: 'WAST',
      dst: 'WAST'
    },
    de: {
      ndst: 'WAST',
      dst: 'WAST'
    }
  }
}, {
  name: 'Indian/Mahe',
  utcOffset: 240,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MST'
    },
    de: {
      ndst: 'MST',
      dst: 'MST'
    }
  }
}, {
  name: 'Indian/Maldives',
  utcOffset: 300,
  abbr: {
    en: {
      ndst: 'WAST',
      dst: 'WAST'
    },
    de: {
      ndst: 'WAST',
      dst: 'WAST'
    }
  }
}, {
  name: 'Indian/Mauritius',
  utcOffset: 240,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MST'
    },
    de: {
      ndst: 'MST',
      dst: 'MST'
    }
  }
}, {
  name: 'Indian/Reunion',
  utcOffset: 240,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MST'
    },
    de: {
      ndst: 'MST',
      dst: 'MST'
    }
  }
}, {
  name: 'MST7MDT',
  utcOffset: -420,
  abbr: {
    en: {
      ndst: 'MST',
      dst: 'MDT'
    },
    de: {
      ndst: 'MST',
      dst: 'MDT'
    }
  }
}, {
  name: 'PST8PDT',
  utcOffset: -480,
  abbr: {
    en: {
      ndst: 'PST',
      dst: 'PDT'
    },
    de: {
      ndst: 'PST',
      dst: 'PDT'
    }
  }
}, {
  name: 'Pacific/Apia',
  utcOffset: 840,
  abbr: {
    en: {
      ndst: 'SST',
      dst: 'SST'
    },
    de: {
      ndst: 'SST',
      dst: 'SST'
    }
  }
}, {
  name: 'Pacific/Auckland',
  utcOffset: 780,
  abbr: {
    en: {
      ndst: 'NZST',
      dst: 'NZDT'
    },
    de: {
      ndst: 'NZST',
      dst: 'NZDT'
    }
  }
}, {
  name: 'Pacific/Bougainville',
  utcOffset: 660,
  abbr: {
    en: {
      ndst: '',
      dst: ''
    },
    de: {
      ndst: '',
      dst: ''
    }
  }
}, {
  name: 'Pacific/Chatham',
  utcOffset: 825,
  abbr: {
    en: {
      ndst: 'CHAST',
      dst: 'CHADT'
    },
    de: {
      ndst: 'CHAST',
      dst: 'CHADT'
    }
  }
}, {
  name: 'Pacific/Easter',
  utcOffset: -300,
  abbr: {
    en: {
      ndst: '',
      dst: ''
    },
    de: {
      ndst: '',
      dst: ''
    }
  }
}, {
  name: 'Pacific/Efate',
  utcOffset: 660,
  abbr: {
    en: {
      ndst: 'CPST',
      dst: 'CPST'
    },
    de: {
      ndst: 'CPST',
      dst: 'CPST'
    }
  }
}, {
  name: 'Pacific/Enderbury',
  utcOffset: 780,
  abbr: {
    en: {
      ndst: 'TST',
      dst: 'TST'
    },
    de: {
      ndst: 'TST',
      dst: 'TST'
    }
  }
}, {
  name: 'Pacific/Fakaofo',
  utcOffset: 780,
  abbr: {
    en: {
      ndst: 'TST',
      dst: 'TST'
    },
    de: {
      ndst: 'TST',
      dst: 'TST'
    }
  }
}, {
  name: 'Pacific/Fiji',
  utcOffset: 720,
  abbr: {
    en: {
      ndst: 'FST',
      dst: 'FST'
    },
    de: {
      ndst: 'FST',
      dst: 'FST'
    }
  }
}, {
  name: 'Pacific/Funafuti',
  utcOffset: 720,
  abbr: {
    en: {
      ndst: 'U',
      dst: 'U'
    },
    de: {
      ndst: 'U',
      dst: 'U'
    }
  }
}, {
  name: 'Pacific/Galapagos',
  utcOffset: -360,
  abbr: {
    en: {
      ndst: 'CAST',
      dst: 'CAST'
    },
    de: {
      ndst: 'CAST',
      dst: 'CAST'
    }
  }
}, {
  name: 'Pacific/Guadalcanal',
  utcOffset: 660,
  abbr: {
    en: {
      ndst: 'CPST',
      dst: 'CPST'
    },
    de: {
      ndst: 'CPST',
      dst: 'CPST'
    }
  }
}, {
  name: 'Pacific/Honolulu',
  utcOffset: -600,
  abbr: {
    en: {
      ndst: 'HAST',
      dst: 'HADT'
    },
    de: {
      ndst: 'HAST',
      dst: 'HADT'
    }
  }
}, {
  name: 'Pacific/Kiritimati',
  utcOffset: 840,
  abbr: {
    en: {
      ndst: '',
      dst: ''
    },
    de: {
      ndst: '',
      dst: ''
    }
  }
}, {
  name: 'Pacific/Kosrae',
  utcOffset: 660,
  abbr: {
    en: {
      ndst: 'CPST',
      dst: 'CPST'
    },
    de: {
      ndst: 'CPST',
      dst: 'CPST'
    }
  }
}, {
  name: 'Pacific/Kwajalein',
  utcOffset: 720,
  abbr: {
    en: {
      ndst: 'U',
      dst: 'U'
    },
    de: {
      ndst: 'U',
      dst: 'U'
    }
  }
}, {
  name: 'Pacific/Majuro',
  utcOffset: 720,
  abbr: {
    en: {
      ndst: 'U',
      dst: 'U'
    },
    de: {
      ndst: 'U',
      dst: 'U'
    }
  }
}, {
  name: 'Pacific/Marquesas',
  utcOffset: -570,
  abbr: {
    en: {
      ndst: '',
      dst: ''
    },
    de: {
      ndst: '',
      dst: ''
    }
  }
}, {
  name: 'Pacific/Nauru',
  utcOffset: 720,
  abbr: {
    en: {
      ndst: 'U',
      dst: 'U'
    },
    de: {
      ndst: 'U',
      dst: 'U'
    }
  }
}, {
  name: 'Pacific/Niue',
  utcOffset: -660,
  abbr: {
    en: {
      ndst: 'U',
      dst: 'U'
    },
    de: {
      ndst: 'U',
      dst: 'U'
    }
  }
}, {
  name: 'Pacific/Norfolk',
  utcOffset: 720,
  abbr: {
    en: {
      ndst: '',
      dst: ''
    },
    de: {
      ndst: '',
      dst: ''
    }
  }
}, {
  name: 'Pacific/Noumea',
  utcOffset: 660,
  abbr: {
    en: {
      ndst: 'CPST',
      dst: 'CPST'
    },
    de: {
      ndst: 'CPST',
      dst: 'CPST'
    }
  }
}, {
  name: 'Pacific/Pago_Pago',
  utcOffset: -660,
  abbr: {
    en: {
      ndst: 'U',
      dst: 'U'
    },
    de: {
      ndst: 'U',
      dst: 'U'
    }
  }
}, {
  name: 'Pacific/Palau',
  utcOffset: 540,
  abbr: {
    en: {
      ndst: 'JST',
      dst: 'JST'
    },
    de: {
      ndst: 'JST',
      dst: 'JST'
    }
  }
}, {
  name: 'Pacific/Pitcairn',
  utcOffset: -480,
  abbr: {
    en: {
      ndst: '',
      dst: ''
    },
    de: {
      ndst: '',
      dst: ''
    }
  }
}, {
  name: 'Pacific/Port_Moresby',
  utcOffset: 600,
  abbr: {
    en: {
      ndst: 'WPST',
      dst: 'WPST'
    },
    de: {
      ndst: 'WPST',
      dst: 'WPST'
    }
  }
}, {
  name: 'Pacific/Rarotonga',
  utcOffset: -600,
  abbr: {
    en: {
      ndst: 'HST',
      dst: 'HST'
    },
    de: {
      ndst: 'HST',
      dst: 'HST'
    }
  }
}, {
  name: 'Pacific/Tahiti',
  utcOffset: -600,
  abbr: {
    en: {
      ndst: 'HST',
      dst: 'HST'
    },
    de: {
      ndst: 'HST',
      dst: 'HST'
    }
  }
}, {
  name: 'Pacific/Tarawa',
  utcOffset: 720,
  abbr: {
    en: {
      ndst: 'U',
      dst: 'U'
    },
    de: {
      ndst: 'U',
      dst: 'U'
    }
  }
}, {
  name: 'Pacific/Tongatapu',
  utcOffset: 780,
  abbr: {
    en: {
      ndst: 'TST',
      dst: 'TST'
    },
    de: {
      ndst: 'TST',
      dst: 'TST'
    }
  }
}, {
  name: 'Pacific/Wake',
  utcOffset: 720,
  abbr: {
    en: {
      ndst: 'U',
      dst: 'U'
    },
    de: {
      ndst: 'U',
      dst: 'U'
    }
  }
}, {
  name: 'Pacific/Wallis',
  utcOffset: 720,
  abbr: {
    en: {
      ndst: 'U',
      dst: 'U'
    },
    de: {
      ndst: 'U',
      dst: 'U'
    }
  }
}];
var getAbbr = function getAbbr(timezone) {
  var _IanaTimezones$find;
  var language = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en';
  var date = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var emptyAbbr = {
    en: {
      ndst: '',
      dst: ''
    },
    de: {
      ndst: '',
      dst: ''
    }
  };
  var abbr = ((_IanaTimezones$find = IanaTimezones.find(function (_ref) {
    var name = _ref.name;
    return name === timezone;
  })) === null || _IanaTimezones$find === void 0 ? void 0 : _IanaTimezones$find.abbr) || emptyAbbr;
  if (!abbr[language]) {
    return '';
  }
  if (date && TimeUtil$1.getIsDst(date, timezone)) {
    return abbr[language].dst;
  }
  return abbr[language].ndst;
};

var Mdx = function Mdx(props) {
  var children = props.children,
    css_class = props.css_class;
  var theme = useTheme();
  return jsx(ReactMarkdown, {
    className: css_class || '',
    remarkPlugins: [remarkGfm],
    rehypePlugins: [rehypeRaw],
    components: {
      code: function code(_ref) {
        var _ref$children = _slicedToArray(_ref.children, 1),
          _ref$children$ = _ref$children[0],
          value = _ref$children$ === void 0 ? null : _ref$children$;
        return ThemedIcon({
          icon: value === null || value === void 0 ? void 0 : value.toString(),
          theme: theme,
          props: {
            className: 'inline'
          }
        });
      }
    }
  }, children || '');
};

function lowPowerMode() {
  return new Promise(function (resolve, reject) {
    var isMobile = BrowserUtil.isMobile();
    var video = document.createElement('video');
    video.src = '';
    video.autoplay = true;
    video.defaultMuted = true;
    video.playsInline = true;
    document.body.appendChild(video);
    video.play().then(function () {
      video.remove();
      resolve(true);
    })["catch"](function (error) {
      video.remove();
      resolve(isMobile && String(error).includes('NotAllowedError'));
    });
  });
}

export { AnalyticsTransformer, BrowserUtil, DebugMenu, DebugMenuContent, FEATURE_FLAGS, IanaTimezones, LoadAnalytics, LocalStorageUtil, MOCK_TIME, MOCK_TIME_ZONE, Mdx, ReactPortal, TimeUtil, getAbbr, lowPowerMode, mustache, withDebugMenuControls };
